import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';

export const toDeclarationExternalType = (country: DeclarationCountry, internalType: DeclarationInternalType) => {
    if (country === 'eu') return 'ICS2';
    if (country === 'uk') return internalType === 'NCTS' ? 'HMRC' : 'CDS';
    return 'REVENUE';
};
